import { render } from "./FacePhotoCell.vue?vue&type=template&id=5bdbf216&scoped=true"
import script from "./FacePhotoCell.vue?vue&type=script&lang=js"
export * from "./FacePhotoCell.vue?vue&type=script&lang=js"

import "./FacePhotoCell.vue?vue&type=style&index=0&id=5bdbf216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdbf216"]])

export default __exports__